import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addfeetype } from "../../store/slices/fees";
import { toast } from "react-hot-toast";
import { FiHome, FiChevronRight } from "react-icons/fi";

export default function AddFeeType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [errors, setErrors] = useState({});

  // Validation
  const validate = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Please enter fee type";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    const payload = {
      name: name.trim(),
    };

    dispatch(addfeetype(payload))
      .unwrap()
      .then(() => {
        toast.success("Fee type added successfully");
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err || "Failed to add fee type");
      });
  };

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">
          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/fee-type">Fee Type</Link>

            <FiChevronRight className="separator" />

            <span className="active">Add Fee Type</span>
          </div>
        </div>
      </div>

      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            <Col md={4} sm={12}>
              <Form.Group>
                <Form.Label>Fee Type</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter fee type"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);

                    if (errors.name) {
                      setErrors((prev) => ({
                        ...prev,
                        name: "",
                      }));
                    }
                  }}
                />

                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </Form.Group>
            </Col>
          </Row>

          <div className="sa-actions mt-4">
            <button
              type="button"
              className="btn-cancel"
              style={{ color: "black" }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button type="submit" className="btn-submit">
              Submit
            </button>
          </div>
        </Form>
      </div>
    </>
  );
}